import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BatteryHighVoltageFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M17.1461 16.0808H0.254883V4.12638H3.76368V1.98438H6.27288V4.12638H11.1281V1.98438H13.6373V4.12638H17.1461V16.0808ZM11.7401 9.40998H9.06768L10.2917 6.88038H9.16968L5.66088 10.9196H8.33328L7.10928 13.4492H8.23128L11.7401 9.40998ZM18.8415 17.0703V8.00977H20.6415V18.8703H4.7998V17.0703H18.8415ZM21.9621 12.8096V20.31H9.6001V22.11H23.7621V12.8096H21.9621Z"
      />
    </SvgIcon>
  );
});
